import { ResforData } from '@/Domain/Resfor'

export class ResforDataDto {
  private _code: string
  private _resforYear: string
  private _resforNif: string
  private _email: string
  private _phone: string
  private _fax: string
  private _mobile: string
  private _provinceCode: number
  private _countyCode: number
  private _parishCode: number
  private _placeCode: number
  private _postalCode: string
  private _resforName: string
  private _resforAddress: string

  public static fromResforData (resforData: ResforData): ResforDataDto {
    return new this(
      resforData.resforCode(),
      resforData.identityCode(),
      resforData.lastComunicationYear(),
      resforData.email(),
      resforData.phone(),
      resforData.fax(),
      resforData.mobile(),
      resforData.provinceCode(),
      resforData.countyCode(),
      resforData.parishCode(),
      resforData.placeCode(),
      resforData.postalCode(),
      resforData.name(),
      resforData.address()
    )
  }

  constructor (
    code: string,
    resforNif: string,
    resforYear: string,
    email: string,
    phone: string,
    fax: string,
    mobile: string,
    provinceCode: number,
    countyCode: number,
    parishCode: number,
    placeCode: number,
    postalCode: string,
    resforName: string,
    resforAddress: string
  ) {
    this._code = code
    this._resforYear = resforYear
    this._resforNif = resforNif
    this._email = email
    this._phone = phone
    this._fax = fax
    this._mobile = mobile
    this._provinceCode = provinceCode
    this._countyCode = countyCode
    this._parishCode = parishCode
    this._placeCode = placeCode
    this._postalCode = postalCode
    this._resforName = resforName
    this._resforAddress = resforAddress
  }

  get resforCode (): string {
    return this._code
  }

  get provinceCode (): number {
    return this._provinceCode
  }

  get countyCode (): number {
    return this._countyCode
  }

  get parishCode (): number {
    return this._parishCode
  }

  get placeCode (): number {
    return this._placeCode
  }

  get lastComunicationYear (): string {
    return this._resforYear
  }

  get identityCode (): string {
    return this._resforNif
  }

  get postalCode (): string {
    return this._postalCode
  }

  get name (): string {
    return this._resforName
  }

  get address (): string {
    return this._resforAddress
  }

  get email (): string {
    return this._email
  }

  get phone (): string {
    return this._phone
  }

  get fax (): string {
    return this._fax
  }

  get mobile (): string {
    return this._mobile
  }
}
